import { RightOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Tabs } from "antd";
import shower from "../../assets/shower.png";
import tv from "../../assets/tv.png";
import color from "../../assets/color.png";
import nor from "../../assets/nor.png";
import mfk from "../../assets/mfk.png";
import { Carousel } from "antd";
import Product from "../Product";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoriesPro } from "../../redux/ecommerce/categoriesProductsSlice";
import { fetchProducts } from "../../redux/ecommerce/productsSlice";

const { TabPane } = Tabs;

const contentStyle = {
  margin: 0,
  height: "160px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
};

const ShopByCategory = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();

  const { categoriesProducts, status, error } = useSelector(
    (state) => state.categoriesProducts
  );

  const { products, statusPro, errorPro } = useSelector(
    (state) => state.products
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCategoriesPro());
    }
  }, [status, dispatch]);

  useEffect(() => {
    if (categoriesProducts.length > 0 && status === "succeeded") {
      categoriesProducts.forEach((category) => {
        dispatch(fetchProducts({ status: "recent", category_id: category.id }));
      });
    }
  }, [categoriesProducts, status, dispatch]);

  const onChange = (key) => {
    console.log(key);
  };

  const renderProducts = (categoryId) => {
    if (statusPro === "loading") {
      return (
        <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
          Loading products...
        </p>
      );
    }

    const categoryProducts = products.filter(
      (product) => product.eco_category_id === categoryId
    );

    if (categoryProducts.length === 0) {
      return (
        <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
          لا توجد منتجات متوفرة في هذه الفئة
        </p>
      );
    }

    const chunkProducts = (products, chunkSize) => {
      const result = [];
      for (let i = 0; i < products.length; i += chunkSize) {
        result.push(products.slice(i, i + chunkSize));
      }
      return result;
    };

    const productChunks = chunkProducts(categoryProducts, 3);

    return (
      <Carousel arrows={productChunks.length > 1} infinite={false}>
        {productChunks.map((chunk, index) => (
          <div key={index}>
            <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-6 px-20 max-lg:px-8 mt-5">
              {chunk.map((product, idx) => (
                <Product
                  key={idx}
                  id={product.id}
                  color_id={product.colors[0]?.id || null}
                  count={1}
                  image={`https://ecommerce.samoolah.com${product.image}`}
                  name={language === "en" ? product.name_en : product.name_ar}
                  price={product.price}
                  link={product.id}
                  favorite={product.favorite}
                />
              ))}
            </div>
          </div>
        ))}
      </Carousel>
    );
  };

  return (
    <div className="mb-20 mt-14 px-20 max-lg:px-5 relative Explore">
      <div className="mb-5">
        <h3 className="text-[#14294F] text-2xl font-semibold">
          {t("Shop By Category")}
        </h3>
      </div>
      <div className="relative Explore">
        {status === "loading" || statusPro === "loading" ? (
          <p className="text-center text-xl text-[#FE9B71]">Loading...</p>
        ) : (
          <Tabs defaultActiveKey="0" className="mt-3" dir="ltr">
            {categoriesProducts.map((category, index) => (
              <TabPane
                tab={
                  <div className="bg-[#FCFBFA] p-5 w-[100px] h-[100px] rounded-xl act flex items-center">
                    <img
                      src={`https://ecommerce.samoolah.com/${category.image}`}
                      alt={category.name}
                      className="w-[50px] mx-auto"
                    />
                  </div>
                }
                key={index}
              >
                {renderProducts(category.id)}
              </TabPane>
            ))}
          </Tabs>
        )}
      </div>
    </div>
  );
};

export default ShopByCategory;
